import { LineWidth } from "@nova/constants"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { useMemo } from "react"

export const LineThicknessPicker = ({
    selectedThickness,
    setSelectedThickness,
    setOpenDropdownId,
    hasNoneOption,
}: {
    selectedThickness: LineWidth
    setSelectedThickness: (width: LineWidth) => void
    setOpenDropdownId: (id: string | undefined) => void
    hasNoneOption?: boolean
}) => {
    const iconByWidth = useMemo<[LineWidth, Icons.IconComponent][]>(() => {
        const list: [LineWidth, Icons.IconComponent][] = [
            [LineWidth.normal, Icons.LineThicknessNormal],
            [LineWidth.thick, Icons.LineThicknessThick],
        ]

        if (hasNoneOption) list.unshift([LineWidth.none, Icons.LineThicknessNone])

        return list
    }, [hasNoneOption])

    return (
        <div className="rounded-xl flex gap-2 p-2 bg-gray-700 shadow-card relative items-center">
            {iconByWidth.map(([width, Icon]) => (
                <div
                    key={width}
                    className={classNames("relative rounded-[0.4375rem] border cursor-pointer", {
                        "border-gray-0 text-gray-0": selectedThickness === width,
                        "border-transparent text-gray-100 hover:text-gray-0":
                            selectedThickness !== width,
                    })}
                    onClick={() => {
                        setSelectedThickness(width)
                        setOpenDropdownId(undefined)
                    }}
                >
                    <Icons.Icon Icon={Icon} />
                </div>
            ))}
        </div>
    )
}
